import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, ShoppingBag, Gift, Menu } from 'lucide-react';
import { createPageUrl } from '../utils';
import DesktopNavbar from './DesktopNavbar';
import SideDrawer from './SideDrawer';
import { useNavigationStack } from '../lib/useNavigationStack';

export default function FullscreenPageWrapper({ children, currentPageName, onMenuClick }) {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { handleTabSelect } = useNavigationStack(currentPageName || 'Home', `/${currentPageName || 'Home'}`);

  const navItems = [
    { name: 'Home', icon: Home, path: createPageUrl('Home') },
    { name: 'Order', icon: ShoppingBag, path: createPageUrl('Order') },
    { name: 'Loyalty', icon: Gift, path: createPageUrl('Loyalty') },
    { name: 'Menu', icon: Menu, action: () => setDrawerOpen(true) }
  ];

  const isActive = (itemName) => {
    return currentPageName?.toLowerCase() === itemName.toLowerCase();
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        * {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .bottom-nav {
          bottom: 0;
          padding-bottom: env(safe-area-inset-bottom, 0px);
        }
      `}</style>
      <DesktopNavbar currentPageName={currentPageName} />
      {children}
      
      <SideDrawer isOpen={drawerOpen} onClose={() => setDrawerOpen(false)} />
      
      {/* Bottom Navigation - Mobile Only */}
      <nav className="bottom-nav lg:hidden fixed bottom-0 left-0 right-0 border-t shadow-lg z-[9999] bg-white" style={{ borderColor: 'rgba(0,0,0,0.1)' }}>
        <div className="px-4 sm:px-6">
          <div className="flex items-center justify-around">
            {navItems.map((item) => {
              const Icon = item.icon;
              const active = isActive(item.name);
              
              const content = (
                <>
                  <Icon 
                    className="w-6 h-6 sm:w-7 sm:h-7 mb-2 transition-colors"
                    style={{ color: '#1A3459' }}
                  />
                  <span 
                    className={`text-[10px] sm:text-xs font-medium`}
                    style={{ color: '#1A3459' }}
                  >
                    {item.name}
                  </span>
                </>
              );
              
              if (item.action) {
                return (
                  <button
                    key={item.name}
                    onClick={item.action}
                    className="flex flex-col items-center py-4 sm:py-5 px-3 sm:px-4 transition-all min-w-[60px] min-h-[60px]"
                  >
                    {content}
                  </button>
                );
              }
              
              return (
                <Link
                  key={item.name}
                  to={item.path}
                  onClick={() => handleTabSelect(active)}
                  className="flex flex-col items-center py-4 sm:py-5 px-3 sm:px-4 transition-all min-w-[60px] min-h-[60px]"
                >
                  {content}
                </Link>
              );
            })}
          </div>
        </div>
      </nav>
    </>
  );
}